<template>
  <div class="modal fade" id="changePasswordModal" module="dialog">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('changePassword') }}</h4>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit="onChangePassword">
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="form-label">{{ $t('oldPassword') }} <span class="text-danger">*</span></label>
                  <input type="password" class="form-control input-sm" v-model="form.oldPassword" required />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="form-label">{{ $t('newPassword') }} <span class="text-danger">*</span></label>
                  <input type="password" class="form-control input-sm" v-model="form.newPassword" required />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="form-label">{{ $t('confirmPassword') }} <span class="text-danger">*</span></label>
                  <input type="password" class="form-control input-sm" v-model="form.confirmPassword" required />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-outline-close" @click="close()">
              <i class="fas fa-times me-1"></i>{{ $t('close') }}
            </button>
            <button type="submit" class="btn btn-sm btn-outline-info-reverse">
              <i class="fas fa-save me-1"></i>{{$t('change') }}
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script lang="ts">
import './ChangePasswordComponent.css';
import agent, { masterServiceBaseURL } from '@/services/agent';
import { defineComponent } from 'vue';
import { ChangePassword, ChangePasswordResponse } from './ChangePassword.model';
import toasterService from '@/services/toasterService';
import modal from '@/components/common/modalManage';
import authService from '@/services/authService';
import passwordValidator from '@/services/passwordValidator';

let _changePasswordForm: ChangePassword = {} as ChangePassword;

export default defineComponent({
  created() {
    agent.setBaseUrl(masterServiceBaseURL);
  },
  data() {
    return {
      form: _changePasswordForm,
      isChangePasswordLoader: false,
    }
  },
  mounted() {
    this.form = {} as ChangePassword;
  },
  methods: {
    async onChangePassword(event: any) {
      event.preventDefault();

      let post = { ...this.form };

      post.email = authService.getUserEmail()

      var passwordValidity = passwordValidator.ValidatePassword(post.newPassword); 

      if (!passwordValidity.isValid) {
          toasterService.warn(this.$t(passwordValidity.message));
          return;
      }

      if (post.newPassword != post.confirmPassword) {
          toasterService.warn(this.$t("msgPasswordConfirmPassword"));
          return;
      }

      agent.setBaseUrl(masterServiceBaseURL);
      const response = await agent.post<ChangePasswordResponse>(`v1/account/changepassword`, post);
      if (response && response.result) {
        this.form = {} as ChangePassword;
        toasterService.success(this.$t('Password changed successfully!'));
        this.close();
      }
    },
    close() {
      this.form = {} as ChangePassword;
      modal.Close('changePasswordModal');
    },
  }
});
</script>
@/services/authService
